import { RootState } from '../types';
import { IUserData } from '../../services/user/types';
import { Roles } from 'constants/roles';

export const UserDataSelector = (state: RootState): IUserData => state.user.userData;
export const UserRoleSelector = (state: RootState): Roles | undefined => state.user.role;
